export const API_ERROR = "api_failed";


//PO Reports
export const VEND_PO_DOC_REPORT = "vend_reports_po_Doc";
export const VEND_PO_DOC_REPORT_SUCCESS = "vend_reports_po_Doc_Successful";
export const PO_DOC_PDF = "report_po_doc_pdf";
